import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { useGetHydratedLessonQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.hooks';
import { GET_HYDRATED_LESSON_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService.dfc.new';
import getLang from 'LearningCenterUI/utils/getLang';
import { ACADEMY_CATALOG_SERVICE_URI } from '../../constants/ApiConstants';
import { getCachedThenNew, quickFetchOrGet } from '../../utils/ajaxUtils';
import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { updateCache } from '../../utils/DataFetchingClientCache';
/**
 * @deprecated
 * Use `useGetHydratedLessonQuery` instead
 */
const GET_LESSON = registerQuery({
  fieldName: 'lesson',
  args: ['lessonId', 'language'],
  fetcher({
    lessonId,
    language
  }) {
    return quickFetchOrGet(`${ACADEMY_CATALOG_SERVICE_URI}/lessons/${lessonId}/${language}`);
  }
});
export const GET_ALL_LESSONS = registerQuery({
  fieldName: 'allLessons',
  args: ['language'],
  fetcher({
    language
  }) {
    const lang = language || getLang();
    return getCachedThenNew(`lessons-${lang}`, `${ACADEMY_CATALOG_SERVICE_URI}/lessons/${lang}?fallbackLanguage=en`).then(response => response);
  }
});
export const GET_LESSON_AVAILABLE_LANGUAGES = registerQuery({
  fieldName: 'lessonAvailableLanguages',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return http.get(`${ACADEMY_CATALOG_SERVICE_URI}/lessons/${lessonId}/available-languages`).then(response => response).then(data => data.map(lang => lang.toUpperCase()));
  }
});
export const fetchAvailableLanguagesByLessonId = lessonId => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_LESSON_AVAILABLE_LANGUAGES,
    variables: {
      lessonId
    }
  });
};

/**
 * @deprecated
 * Use `updateFullLessonCacheChirp` instead
 */
export const updateFullLessonCache = (lessonData, language) => {
  updateCache(GET_LESSON, () => lessonData, {
    language: language === null || language === void 0 ? void 0 : language.toLowerCase(),
    lessonId: lessonData.id
  });
};
export const updateFullLessonCacheChirp = (lessonData, language) => {
  const lessonLanguage = !language ? getLang().toUpperCase() : language;
  updateCache(GET_HYDRATED_LESSON_QUERY, () => ({
    lesson: lessonData
  }), {
    lessonId: lessonData.id,
    language: lessonLanguage
  });
};
export const updatePartialLessonCache = (lessonData, language = getLang()) => {
  updateCache(GET_ALL_LESSONS, allLessonsCache => {
    if (!allLessonsCache.result) {
      return {
        result: [lessonData],
        timestamp: new Date().getTime()
      };
    }
    const existingLessonIdx = allLessonsCache.result.findIndex(cachedLesson => cachedLesson.id === lessonData.id);
    if (existingLessonIdx > -1) {
      allLessonsCache.result[existingLessonIdx] = lessonData;
    }
    allLessonsCache.result.push(lessonData);
    return allLessonsCache;
  }, {
    language: language.toLowerCase()
  });
};

/**
 * @deprecated
 * Use `useFullLessonChirp` instead
 */
export const useFullLesson = (lessonId, language = getLang(), skip, fetchPolicy) => {
  if (!language || !language.length) language = getLang();
  const {
    loading: lessonLoading,
    data: lesson,
    error: lessonError
  } = useQuery(GET_LESSON, {
    variables: {
      lessonId,
      language: language.toLowerCase()
    },
    skip: skip || lessonId === null || isNaN(lessonId),
    fetchPolicy
  });
  return {
    lesson,
    lessonLoading,
    lessonError
  };
};
export const useFullLessonChirp = ({
  lessonId,
  language,
  skip,
  fetchPolicy
}) => {
  const lessonLanguage = !language ? getLang().toUpperCase() : language;
  const {
    loading: lessonLoading,
    data,
    error: lessonError
  } = useGetHydratedLessonQuery({
    variables: {
      lessonId,
      language: lessonLanguage
    },
    skip: skip || lessonId === null || isNaN(lessonId),
    fetchPolicy
  });
  return {
    lesson: data === null || data === void 0 ? void 0 : data.lesson,
    lessonLoading,
    lessonError
  };
};
export const getFullLesson = variables => dataFetchingClient.queryUnwrapped({
  query: GET_HYDRATED_LESSON_QUERY,
  variables
}).then(response => response.lesson);
export const getAllLessons = (language = getLang()) => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_ALL_LESSONS,
    variables: {
      language: language.toLowerCase()
    }
  });
};
export const useLessonContentById = ({
  lessonId,
  contentId,
  language,
  fetchPolicy,
  skip
}) => {
  const {
    lesson
  } = useFullLessonChirp({
    lessonId,
    language,
    skip,
    fetchPolicy
  });
  if (!lesson) {
    return undefined;
  }
  return lesson.content.find(content => content.id === contentId);
};